// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1OSyD","approved":"Status_approved__2PJjZ","rejected":"Status_rejected__2NB_e","expired":"Status_expired__C9s-n","label":"Status_label__5_-AN"};